import type { ChangeEvent, FC } from 'react';

interface PanelSearchInputProps {
  onChange: (value: string) => void;
  placeholder: string;
  ariaLabel: string;
  autoFocus?: boolean;
  value?: string;
}

export const PanelSearchInput: FC<PanelSearchInputProps> = ({ value, onChange, placeholder, ariaLabel, autoFocus }) => (
  <div className="p-2 border-b border-black/5">
    <input
      // biome-ignore lint/a11y/noAutofocus: Search input in a popover panel benefits from autofocus.
      autoFocus={autoFocus}
      value={value}
      type="text"
      onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label={ariaLabel}
      className="w-full px-3 py-1.5 text-base sm:text-sm rounded-full bg-black/5 outline-none focus:ring-2 focus:ring-black/20"
    />
  </div>
);
